var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@emotion/styled';
import { display, fontSize, space, lineHeight, fontWeight, } from 'styled-system';
import { Button } from '../../../common/components/Button';
import { themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, } from '../../../common/theme/system-utilities';
import Icon from '../../../common/components/Icon';
var SearchButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  box-shadow: none;\n  ", ";\n  ", ";\n"], ["\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  box-shadow: none;\n  ", ";\n  ",
    ";\n"])), space, function (props) {
    var transitionState = props.transitionState, timeout = props.timeout;
    // Search button should appear, when form unlocks the screen (exit state),
    // this is why we consider that button appears to be on 'exiting', 'exited'
    // states
    var appear = ['exiting', 'exited'].includes(transitionState);
    return __assign({ top: 0, bottom: 0, right: 0, transitionProperty: 'transform, opacity', position: transitionState === 'exited' ? 'relative' : 'absolute' }, (appear
        ? {
            opacity: 1,
            transform: 'translateX(0)',
            transitionTimingFunction: 'ease-out',
            pointerEvents: 'initial',
            transitionDuration: timeout / 2 + "ms",
        }
        : {
            opacity: 0,
            transform: 'translateX(100%)',
            transitionTimingFunction: 'ease-in',
            pointerEvents: 'none',
            transitionDelay: timeout / 2 + "ms",
            transitionDuration: timeout / 2 + "ms",
        }));
});
SearchButton.defaultProps = {
    as: Button,
    py: 1,
    pl: [1, null, 2],
    pr: [1, null, 3],
};
var SearchButtonIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, space);
SearchButtonIcon.defaultProps = {
    themeWidth: 5,
    themeMaxWidth: 5,
    themeHeight: 5,
    themeMaxHeight: 5,
};
var SearchButtonLabel = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), display, space, fontSize, fontWeight, lineHeight);
SearchButtonLabel.defaultProps = {
    display: ['none', null, 'inline'],
    ml: 1,
    fontSize: 4,
    fontWeight: 'bold',
    lineHeight: 3,
};
export var SearchSubmitButton = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(SearchButton, __assign({ type: "submit", "aria-labelledby": "search-button-label" }, props),
        React.createElement(SearchButtonIcon, { name: "search", dataTestId: "search-button-icon", ariaHidden: true }),
        React.createElement(SearchButtonLabel, { id: "search-button-label", "data-testid": "search-button-label" }, children)));
};
var templateObject_1, templateObject_2, templateObject_3;
